const debounce = (fn, delay) => {
  let timer
  const executedFunction = (...args) => {
    const self = this
    clearTimeout(timer)
    timer = setTimeout(() => {
      timer = null
      fn.apply(self, args)
    }, delay)
  }
  executedFunction.cancel = () => {
    clearTimeout(timer)
  }
  return executedFunction
}

export default debounce
